import { render, staticRenderFns } from "./elc.vue?vue&type=template&id=407cc4e2&scoped=true"
import script from "./elc.vue?vue&type=script&lang=js"
export * from "./elc.vue?vue&type=script&lang=js"
import style0 from "./elc.vue?vue&type=style&index=0&id=407cc4e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "407cc4e2",
  null
  
)

export default component.exports